/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DashboardGlobalDto } from '../models/dashboard-global-dto';
import { DashboardParcDto } from '../models/dashboard-parc-dto';


/**
 * Fonctions de gestion des dashboards
 */
@Injectable({
  providedIn: 'root',
})
export class DashboardsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation dashboardGetGlobal
   */
  static readonly DashboardGetGlobalPath = '/api/dashboard/global';

  /**
   * Renvoie le dashboard global.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardGetGlobal()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGetGlobal$Response(params?: {
  }): Observable<StrictHttpResponse<DashboardGlobalDto>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardsService.DashboardGetGlobalPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DashboardGlobalDto>;
      })
    );
  }

  /**
   * Renvoie le dashboard global.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dashboardGetGlobal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGetGlobal(params?: {
  }): Observable<DashboardGlobalDto> {

    return this.dashboardGetGlobal$Response(params).pipe(
      map((r: StrictHttpResponse<DashboardGlobalDto>) => r.body as DashboardGlobalDto)
    );
  }

  /**
   * Path part for operation dashboardGetParc
   */
  static readonly DashboardGetParcPath = '/api/dashboard/{parcId}';

  /**
   * Renvoie le dashboard du parc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardGetParc()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGetParc$Response(params: {

    /**
     * L&#x27;identifiant du parc.
     */
    parcId: number;
  }): Observable<StrictHttpResponse<DashboardParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardsService.DashboardGetParcPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DashboardParcDto>;
      })
    );
  }

  /**
   * Renvoie le dashboard du parc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dashboardGetParc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGetParc(params: {

    /**
     * L&#x27;identifiant du parc.
     */
    parcId: number;
  }): Observable<DashboardParcDto> {

    return this.dashboardGetParc$Response(params).pipe(
      map((r: StrictHttpResponse<DashboardParcDto>) => r.body as DashboardParcDto)
    );
  }

}
